import { render } from "./UserPasswordForm.vue?vue&type=template&id=3c8a3367&ts=true"
import script from "./UserPasswordForm.vue?vue&type=script&lang=ts"
export * from "./UserPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__